module.exports = __webpack_public_path__ + "packs/media/images/badges/traverso_verde-6e708162b14dfbfd3e0955900c39840f.png";